import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";
import { alignVariants } from "../../utils/vanilla/alignVariants";

export const textStyle = style({
  vars: {
    "--node-margin": theme.spacings.m,
  },
  selectors: {
    "&[href]:hover": {
      textDecoration: "underline",
    },
  },
});

export const currentColor50Style = style({
  color: "currentColor",
  opacity: 0.5,
});

export const currentColor25Style = style({
  color: "currentColor",
  opacity: 0.25,
});

export const currentColor75Style = style({
  color: "currentColor",
  opacity: 0.75,
});

export const textRecipeStyle = recipe({
  variants: {
    alignSelf: {
      ...alignVariants("alignSelf"),
    },
    ellipsis: {
      true: {
        width: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        display: "block",
      },
    },
    strikeThrough: {
      true: {
        textDecoration: "line-through",
      },
    },
    grow: {
      true: {
        flexGrow: 1,
      },
    },
    shrink: {
      true: {
        flexShrink: 1,
      },
      false: {
        flexShrink: 0,
      },
    },
    inline: {
      true: {
        display: "inline",
      },
    },
    noWrap: {
      true: {
        whiteSpace: "nowrap",
      },
    },
    bold: {
      true: {
        fontWeight: "bold",
      },
      "600": {
        fontWeight: "600",
      },
      "500": {
        fontWeight: "500",
      },
    },
    italic: {
      true: {
        fontStyle: "italic",
      },
    },
    align: {
      center: {
        textAlign: "center",
      },
      right: {
        textAlign: "right",
      },
      left: {
        textAlign: "left",
      },
      justify: {
        textAlign: "justify",
      },
    },
  },
  defaultVariants: {
    align: "left",
  },
});

export const clampStyle = style({
  width: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: "-webkit-box",
  lineClamp: "var(--clamp, 3)",
  WebkitLineClamp: "var(--clamp, 3)",
  boxOrient: "vertical",
  WebkitBoxOrient: "vertical",
});
